import { useLayoutContext } from '../../../Context/Layout.context';
import { updateMainPage } from '../../../services/support/mainPage/mainPage.service';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { IMainPage } from '../../../services/support/mainPage/mainPage.types';
import { MainPageEditor } from '../MainPageEditor/MainPageEditor.component';

interface EditMainPageProps {
  onClose: () => void;
  onChange: () => void;
  mainPageProp: IMainPage;
}

export const EditMainPage: React.FC<EditMainPageProps> = ({ onClose, onChange, mainPageProp: mainPageProp }) => {

  const handleClose = () => {
    onClose();
  };

  const { openAlert } = useLayoutContext();
  useDocumentTitle('Edytuj opis nagłówka');

  const handleEditMainPage = (htmlContent: string) => {
    updateMainPage(htmlContent).then(
      () => {
        openAlert('success', 'Dane zostały pomyślnie zapisane');
        onChange();
        onClose();
      },
      () => {
        openAlert('save_error');
      },
    );
  };

  return (
    <MainPageEditor
      title="Edytuj opis nagłówka"
      onCancel={handleClose}
      onSave={handleEditMainPage}
      onChange={onChange}
      htmlContent={mainPageProp.htmlContent}
    />
  );
};
